import { ActionReducerMapBuilder, createAsyncThunk } from '@reduxjs/toolkit'
import Container from 'typedi'
import { RestApiService } from '@/services'

import { ApplicationState } from '@/state/root.models'
import { setLoadingFullAction } from '@/state/ui/global/slices/index.slices'
import { PlayerCardActionTypes } from '../constants'

import { PLAYER_CARD } from './api.routes'
import { PlayerCardModels } from '../'

const apiService: RestApiService = Container.get(RestApiService)

export const getCountriesListThunk = createAsyncThunk(
  PlayerCardActionTypes.GET_COUNTRIES_LIST,
  async (_, thunkAPI) => {
    try {
      thunkAPI.dispatch(setLoadingFullAction(true))

      const { auth } = thunkAPI.getState() as ApplicationState

      apiService.requestParams = {
        method: 'GET',
        endpoint: PLAYER_CARD.GET_COUNTRIES_LIST,
        externalServerURL:
          process.env && process.env.REACT_APP_SERVER_CASINO_API,
      }

      const response: any = await apiService.getData(
        auth.brand.siteId.toString(),
        auth.token,
      )

      thunkAPI.dispatch(setLoadingFullAction(false))

      return response
    } catch (error) {
      thunkAPI.dispatch(setLoadingFullAction(false))
    }
  },
)

export const getCountriesListExtraReducer = (
  builder: ActionReducerMapBuilder<PlayerCardModels.PlayerCardState>,
) => {
  builder.addCase(getCountriesListThunk.fulfilled, (state, { payload }) => {
    state.countriesList = payload
  })
}
